<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">封禁记录</span>
        </div>
        <div>
            <Input
                v-model="filterData.be_report_invite_code"
                maxlength="6"
                placeholder="被举报人身份ID"
                clearable
                style="min-width: 80px; width:150px; margin-right: 10px;"/>
            <Button @click="pageOption.page = 1,getData()">搜索</Button>
        </div>
      </div>
      <Modal
        @on-ok="updateDetentionRecordNew(1)"
        title="确认修改期限么？"
        v-model="modalUpdateDetention"
        :closable="false"
        :mask-closable="false"
      >
        <div class="modal1-div">{{modalUpdateDetentionData.desc}}</div>
        <div class="modal1-div">
          <span>修改为</span>
          <Input
            v-model="modalUpdateDetentionData.ban_days"
            size="small"
            placeholder="输入修改天数"
            clearable
            style="min-width: 100px; width:30%"
          />
          <span>天</span>
        </div>
        <div class="modal1-div">将在{{getModalUpdateDetentionMsg}}</div>
      </Modal>
      <Modal
        @on-ok="updateDetentionRecord(2)"
        title="确认放出该用户么？"
        v-model="modalReleaseDetention"
        :closable="false"
        :mask-closable="false"
      >
        <div class="modal1-div">确认后该用户将解封</div>
      </Modal>
      <Drawer
        :closable="true"
        :mask="true"
        :scrollable="true"
        width="300"
        v-model="showUserDetentionRecord"
      >
        <p :style="pStyle">用户封禁详情：{{currentBeReporterInviteCode}}</p>
        <div v-if="reporterDetentionInfo.records[0].length !== 0" class>
          <div
            style="margin-bottom: 25px"
            v-show="reporterDetentionInfo.status === 1"
            class="detention-info"
          >
            {{reporterDetentionInfo.record_time}}
            <br />
            {{reporterDetentionInfo.detention_type}}，{{reporterDetentionInfo.who_detention}}{{reporterDetentionInfo.ban_days}}
            <br />
            <Button
              style="margin-right: 20px"
              size="small"
              @click="updateDetentionRecordButton"
            >修改期限</Button>
            <Button size="small" @click="releaseDetentionRecordButton">立即放出</Button>
          </div>
          <div style="margin-bottom: 25px" v-for="recordInfo in reporterDetentionInfo.records">
            <div style="margin-bottom: 5px" v-for="item in recordInfo">
              {{item.record_time}}
              <br />
              {{item.record_desc}}{{item.ban_days}}
            </div>
          </div>
        </div>
        <div v-else>暂无封禁记录～</div>
      </Drawer>
      <Table :columns="columns" :data="changeDataList" @on-selection-change="selected">
        <template slot-scope="{ row, index }" slot="id">
          <span>{{ row.id }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="avatar">
            <Poptip trigger="hover" :transfer="true" title="图片详情">
                <div class="info-pop" slot="content">
                    <img :src="row.avatar">
                </div>
                <img :src="row.avatar" style="width: 48px;height: 48px;margin-top: 5px;">
            </Poptip>
        </template>

        <template slot-scope="{ row, index }" slot="nickname">
         <span>{{ row.nickname }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="invite_code">
          <span>{{ row.invite_code }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="report_type">
          <span>{{ row.type_title }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="detention_time">
          <span>{{ row.detention_time }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="released_time">
          <span>{{ row.released_time }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="baned_days">
          <span>{{ row.baned_days }}</span>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <div>
            <Button
              type="primary"
              size="small"
              @click="be_report_status_click(row)"
            >状态</Button>
          </div>
        </template>
      </Table>
      <div class="text-center" style="margin-top: 10px;" v-show="dataList.length >1">
        <Page
          show-elevator
          :page-size="pageOption.page_size"
          :total="pageOption.total"
          @on-change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";
import commonApi from "../../utils/commonapi";

export default {
  name: "ReportCheck",
  components: {},
  watch: {
  },
  data() {
    return {
      filterOption: {
        datetime: [],
        reportTypeList: [],
      },
      pStyle: {
        fontSize: '16px',
        color: 'rgba(0,0,0,0.85)',
        lineHeight: '24px',
        display: 'block',
        marginBottom: '16px'
      },
      filterData: {
        datetime: ["", ""],
        be_report_invite_code: null,
        be_report_status: null,
        report_type: null,
        report_status: null,
        report_content: null,
        reporter_invite_code: null
      },
      reporterDetentionInfo: {
        status: 0,
        record_time: null,
        who_detention: null,
        detention_type: null,
        ban_days: null,
        records: [[]]
      },
      selectedItem: [],
      selectedId: [],
      dataList: [],
      avatar: null,  // 被举报人头像
      columns: [
        {
          title: 'id',
          width: 100,
          slot: 'id',
        },
        {
          title: '头像',
          slot: 'avatar'
        },
        {
          title: '昵称',
          slot: 'nickname'
        },
        {
          title: '身份ID',
          slot: 'invite_code'
        },
        {
          title: '举报类型',
          slot: 'report_type'
        },
        
        {
          title: '关入时间',
          slot: 'detention_time'
        },
        {
          title: '放出时间',
          slot: 'released_time'
        },
        {
          title: '已封禁天数',
          slot: 'baned_days',
          width: 160
        },
        {
          title: '操作',
          slot: 'action',
          width: 130
        }
      ],
      pageOption: {
        page_size: 20,
        total: 100,
        page: 1
      },
      modal1: false,
      modalCHeckReject: false,
      modalCheckBatchAgree: false,
      modalUpdateDetention: false,
      modalReleaseDetention: false,
      showUserDetentionRecord: false,
      modal1Data: {
        report_type: null,
        ban_days: null,
        detention_time: null,
        msg: null
      },
      modalUpdateDetentionData: {
        desc: null,
        detention_time: null,
        ban_days: 0,
        min_ban_days: null
      },
      currentRow: {},
      currentBeReporterInviteCode: null,
    }
  },
  created() {
    // this.getData();
  },
  methods: {
    pageChange(page) {
      this.pageOption.page = page;
      this.getData()
    },
    test(index) {
      console.log(index)
      console.log(this.filterData.datetime)
    },
    changeDate() {
      if (this.filterOption.datetime) {
        if (this.filterOption.datetime[0] !== "") {
          this.filterData.datetime = [
            this.$moment(this.filterOption.datetime[0]).format("YYYY-MM-DD HH:mm:ss"),
            this.$moment(this.filterOption.datetime[1]).format("YYYY-MM-DD HH:mm:ss")
          ];
        }
      }
    },
    getData() {
      if(this.filterData.be_report_invite_code == undefined){
          alert('请输入被举报人身份ID')
          return 
      }
      let params = {
        page: this.pageOption.page,
        page_size: this.pageOption.page_size,
        invite_code: this.filterData.be_report_invite_code
      };
      apis.co_time_report_user_detention(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.pageOption.total = data.count;
          var list = []
          list[0] = data.record
          console.log(JSON.stringify(list))
          this.dataList =list;
        }else{
          alert(msg)
        }
      }).catch(err => {
        alert("接口异常")
      })
    },
    selected(selecttion) {
      this.selectedId = [];
      this.selectedItem = selecttion;
      selecttion.forEach(item => {
        this.selectedId.push(item.id)
      })
      console.log(this.selectedId)
    },
    be_report_status_click(row) {
      this.showUserDetentionRecord = true
      this.getUserDetentionInfo(row.invite_code)
      this.currentBeReporterInviteCode = row.invite_code
      this.currentRow = row
    },
    getUserDetentionInfo(invite_code) {
      let params = {
        invite_code: invite_code
      }
      apis.co_time_report_get_user_detention_record(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.reporterDetentionInfo.status = data.status;
          this.reporterDetentionInfo.record_time = data.record_time;
          this.reporterDetentionInfo.who_detention = data.who_detention;
          this.reporterDetentionInfo.detention_type = data.detention_type;
          this.reporterDetentionInfo.ban_days = data.ban_days;
          this.reporterDetentionInfo.records = data.records
        } else {
          alert(msg)
        }
      }).catch()
    },
    updateDetentionRecordButton() {
      this.getBeReporterLastStatus();
      this.modalUpdateDetention = true
    },
    releaseDetentionRecordButton() {
      this.modalReleaseDetention = true
    },
    getBeReporterLastStatus() {
      let params = {
        invite_code: this.currentBeReporterInviteCode
      };
      apis.co_time_report_get_be_reporter_last_status(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.modalUpdateDetentionData.desc = data.desc;
          this.modalUpdateDetentionData.detention_time = data.detention_time;
          this.modalUpdateDetentionData.ban_days = data.min_ban_days
        } else {
          alert(msg)
        }
      }).catch(err => {
        alert('接口异常')
      })
    },
    updateDetentionRecord(type) {
      if (type === 1 && this.modalUpdateDetentionData.ban_days < 1) {
        alert('天数不能小于1')
        return
      }
      let post_data = {
        update_type: type,
        invite_code: this.currentBeReporterInviteCode,
        detention_time: this.modalUpdateDetentionData.detention_time,
        ban_days: this.modalUpdateDetentionData.ban_days,
        detention_type: this.reporterDetentionInfo.detention_type
      };
      apis.co_time_report_update_detention_record(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.showUserDetentionRecord = false
          // 记录-举报处理-解封用户
          commonApi.recordFromOperationReport(3, null, 0, this.currentRow.id, '解封用户，邀请码：'+this.currentBeReporterInviteCode)
          setTimeout(() => {
             this.getData()
          }, 500);
         
        } else {
          alert(msg)
        }
      }).catch(err => {
        alert('接口异常')
      })

    },
    updateDetentionRecordNew(type) {
      if (type === 1 && this.modalUpdateDetentionData.ban_days < 1) {
        alert('天数不能小于1')
        return
      }
      if (this.currentRow.id == undefined || this.currentRow.id<=0 ) {
        alert('当前用户信息异常')
        return
      }
      let post_data = {
        user_id: this.currentRow.id,
        detention_time: this.modalUpdateDetentionData.detention_time,
        ban_days: parseInt(this.modalUpdateDetentionData.ban_days),
        detention_type: this.currentRow.report_type,
      };
      apis.co_time_report_ban_user(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          // 记录-举报处理-解封用户
          commonApi.recordFromOperationReport(4, null, 0, this.currentRow.id, '修改期限，邀请码：'+this.currentBeReporterInviteCode+'，'+parseInt(this.modalUpdateDetentionData.ban_days)+'天')
          alert('修改封禁期限成功')
          this.showUserDetentionRecord = false
          this.getData()
        } else {
          alert(msg)
        }
      }).catch(err => {
        alert('接口异常')
      })
    },
  },
  computed: {
    getModal1Msg() {
      if (this.modal1Data.detention_time) {
        let endDateTime = this.$moment(this.modal1Data.detention_time).add(this.modal1Data.ban_days, 'days').format("YYYY-MM-DD")
        return endDateTime + ' 放出'
      } else {
        let endDateTime = this.$moment().add(this.modal1Data.ban_days, 'days').format("YYYY-MM-DD")
        return endDateTime + ' 放出'
      }
    },
    getModalUpdateDetentionMsg() {
      if (this.modalUpdateDetentionData.detention_time) {
        let endDateTime = this.$moment(this.modalUpdateDetentionData.detention_time).add(this.modalUpdateDetentionData.ban_days, 'days').format("YYYY-MM-DD")
        return endDateTime + ' 放出'
      } else {
        let endDateTime = this.$moment().add(this.modalUpdateDetentionData.ban_days, 'days').format("YYYY-MM-DD")
        return endDateTime + ' 放出'
      }
    },
    changeDataList() {
        return this.dataList.map(item => {
          item['_disabled'] = true
          var avatar = item['avatar']
          if(avatar == undefined || avatar == ""){
              avatar = "webco.png"
          }
          if(avatar.startsWith("http")){
              
          }else{
              item['avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
          }
          // 举报的类型
          var type = item['report_type']
          var typeList = ["其他","垃圾营销","涉黄信息","人身攻击","有害信息","违法信息","咋骗信息","虚假信息"]
          if(type == undefined || type >7){
              type = 0
          }
          item['type_title'] = typeList[type]
          return item
        })
    }
  },
  filters: {
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}

.avatar{
    width: 48px;
    height: 48px;
}
</style>
